import {COLORS} from 'redux/actionTypes';
import Api from 'services/Api';

export const addColor = (color) => {
	return (dispatch) => {
		dispatch({
			type: COLORS.ADD,
			payload: {
				color
			}
		});
	}
}

export const selectColor = (color) => {
	return (dispatch) => {
		dispatch({
			type: COLORS.SELECT,
			payload: {
				color
			}
		});
	}
}

export const save = (params, callback) => {
	return (dispatch) => {
		dispatch({
			type: COLORS.LOADING,
		});
		Api.post(
			params,
			'colors/add/palette',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				return dispatch(set(data.palettes, data.index, callback));
			},
			'get'
		);
	};
};

export const set = (palettes, index = 0, callback) => {
	return (dispatch) => {
		if (typeof callback === 'function') {
			callback();
		}
		return dispatch({
			type: COLORS.SET,
			payload: {
				palettes,
				index
			}
		});
	}
}
